var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrophyIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint0_linear_3401_3336)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3401_3336",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3401_3336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 29V27H19V23.9C18.1833 23.7167 17.4542 23.3708 16.8125 22.8625C16.1708 22.3542 15.7 21.7167 15.4 20.95C14.15 20.8 13.1042 20.2542 12.2625 19.3125C11.4208 18.3708 11 17.2667 11 16V15C11 14.45 11.1958 13.9792 11.5875 13.5875C11.9792 13.1958 12.45 13 13 13H15V11H25V13H27C27.55 13 28.0208 13.1958 28.4125 13.5875C28.8042 13.9792 29 14.45 29 15V16C29 17.2667 28.5792 18.3708 27.7375 19.3125C26.8958 20.2542 25.85 20.8 24.6 20.95C24.3 21.7167 23.8292 22.3542 23.1875 22.8625C22.5458 23.3708 21.8167 23.7167 21 23.9V27H25V29H15ZM15 18.8V15H13V16C13 16.6333 13.1833 17.2042 13.55 17.7125C13.9167 18.2208 14.4 18.5833 15 18.8ZM20 22C20.8333 22 21.5417 21.7083 22.125 21.125C22.7083 20.5417 23 19.8333 23 19V13H17V19C17 19.8333 17.2917 20.5417 17.875 21.125C18.4583 21.7083 19.1667 22 20 22ZM25 18.8C25.6 18.5833 26.0833 18.2208 26.45 17.7125C26.8167 17.2042 27 16.6333 27 16V15H25V18.8Z",
    fill: "#1C1B1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3401_3336",
    x1: 40,
    y1: 0,
    x2: 0.00000476837,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8BA3C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyIcon);
export default __webpack_public_path__ + "static/media/trophy-icon.32ba7bac85cd81ecd57c2d91bdf8ca1b.svg";
export { ForwardRef as ReactComponent };